/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {memo, useEffect, useRef} from 'react'
import ApexCharts, {ApexOptions} from 'apexcharts'
import {getCSSVariableValue} from '../../../assets/ts/_utils'
import {ChartSeries} from './types'



type Props = {
  chartOptions: {
    series: ChartSeries[]
    categoriesXAxis: string[]
  }
}

const ChartsWidget4: React.FC<Props> = memo(({chartOptions}) => {
  const chartRef = useRef<HTMLDivElement | null>(null)

  useEffect(() => {
    if (!chartRef.current) {
      return
    }

    // const height = parseInt(getCSS(chartRef.current, 'height'))

    const chart = new ApexCharts(chartRef.current, getChartOptions(400, chartOptions.series, chartOptions.categoriesXAxis))
    if (chart) {
      chart.render()
    }

    return () => {
      if (chart) {
        chart.destroy()
      }
    }
  }, [chartRef, chartOptions.series])

  return (
    <div className="">

      {/* begin::Body */}
      <div className=''>
        {/* begin::Chart */}
        <div ref={chartRef} id='kt_charts_widget_4_chart' style={{height: '350px'}}></div>
        {/* end::Chart */}
      </div>
      {/* end::Body */}
    </div>
  )
})

export {ChartsWidget4}

function getChartOptions(height: number, series: ChartSeries[], categoriesXAxis: string[]): ApexOptions {
  const labelColor = getCSSVariableValue('--bs-gray-500')
  const baseLightColor = getCSSVariableValue('--bs-light-success')
  const secondaryLightColor = getCSSVariableValue('--bs-light-warning')
  const primaryColor = getCSSVariableValue('--bs-primary')
  const dangerLightColor = getCSSVariableValue('--bs-light-danger')

  return {
    series,
    chart: {
      fontFamily: 'inherit',
      type: 'line',
      height,
      toolbar: {
        show: false,
      },

    },
    plotOptions: {},
    legend: {
      show: false,
    },
    dataLabels: {
      enabled: false,
    },
    fill: {

      // type: 'gradient',
      opacity: 1,
    },
    stroke: {
      curve: 'smooth',
    },
    xaxis: {
      categories: categoriesXAxis,
      axisBorder: {
        show: false,
      },
      axisTicks: {
        show: false,
      },
      labels: {
        style: {
          colors: labelColor,
          fontSize: '12px',
        },
      },
      crosshairs: {
        position: 'front',
        stroke: {
          color: labelColor,
          width: 1,
          dashArray: 3,
        },
      },
      tooltip: {
        enabled: true,
        formatter: undefined,
        offsetY: 0,
        style: {
          fontSize: '12px',
        },
      },
    },
    yaxis: {
      labels: {
        style: {
          colors: labelColor,
          fontSize: '12px',
        },
      },
    },
    states: {
      normal: {
        filter: {
          type: 'none',
          value: 0,
        },
      },
      hover: {
        filter: {
          type: 'none',
          value: 0,
        },
      },
      active: {
        allowMultipleDataPointsSelection: false,
        filter: {
          type: 'none',
          value: 0,
        },
      },
    },
    tooltip: {
      style: {
        fontSize: '12px',
      },
      y: {
        formatter: val => '' + val,
      },
    },
    // colors: [baseColor, secondaryColor],
    // grid: {
    //   borderColor: borderColor,
    //   strokeDashArray: 4,
    //   yaxis: {
    //     lines: {
    //       show: true,
    //     },
    //   },
    // },
    markers: {
      colors: [baseLightColor, secondaryLightColor, primaryColor, dangerLightColor],
      strokeColors: [baseLightColor, secondaryLightColor, primaryColor, dangerLightColor],
      strokeWidth: 3,
    },
  }
}
